import React, { useEffect } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  showCloseButton?: boolean;
  closeOnEsc?: boolean;
  closeOnBackdrop?: boolean;
  panelClassName?: string;
  backdropClassName?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  showCloseButton = true,
  closeOnEsc = true,
  closeOnBackdrop = false,
  panelClassName = "bg-white p-6 rounded-lg shadow-lg w-[400px] relative",
  backdropClassName = "fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50",
}) => {
  useEffect(() => {
    if (!closeOnEsc) return;
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose, closeOnEsc]);

  if (!isOpen) return null;

  return (
    <div
      className={backdropClassName}
      onMouseDown={() => {
        if (closeOnBackdrop) onClose();
      }}
    >
      <div
        className={panelClassName}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
      >
        {showCloseButton && (
          <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 hover:text-gray-800">
            ✖
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
